<!-- RecipeArticles component show list of articles related to the recipe -->
<template>
  <div v-if="articles.length > 0" class="recipe-articles-container mt-4">
    <h4 class="mb-3">Cтатьи о рецепте:</h4>
    <div class="articles-scroll-list" v-for="article in articles" :key="article.id">
        <p class="text-start"><a :href="'#/article/' + article.id">{{ article.title }}</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeArticles",
  props: {
    recipeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      articles: [],
      isLoading: false,
      error: null,
    };
  },
  mounted() {
    this.fetchRecipeArticles();
  },

  methods: {
    async fetchRecipeArticles() {
      this.isLoading = true;
      this.error = null;
      this.articles = [];
      try {
        const command = `article.getByRecipe/${this.recipeId}`;
        const response = await this.sendCmd(command);
        const parsedResponse = JSON.parse(response);
        const unpackedJsonString = await this.unpackData(parsedResponse.data);
        this.articles = JSON.parse(unpackedJsonString);
      } catch (err) {
        this.error = "Не удалось загрузить другие истории.";
        console.error("Error fetching similar articles:", err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
